/** Resolve FAQ header + items for the active locale (CMS may store q/a + optional *_fr). */
export function resolveFaqContent(cms, locale, t, fallbackFaqs) {
  const f = cms || {};
  const isFr = locale === "fr";

  const title = isFr ? f.title_fr || t("faq.title") : f.title || t("faq.title");
  const description = isFr
    ? f.description_fr || t("faq.description")
    : f.description || t("faq.description");

  const rawItems = f.items?.length ? f.items : fallbackFaqs;
  const items = rawItems.map((item, i) => {
    const fb = fallbackFaqs[i];
    if (isFr) {
      return {
        q: item.q_fr || fb?.q || item.q,
        a: item.a_fr || fb?.a || item.a,
      };
    }
    return {
      q: item.q ?? fb?.q ?? "",
      a: item.a ?? fb?.a ?? "",
    };
  });

  return { title, description, items };
}
